import React from "react";
import { Banner } from "../components/Banner";
import { WhyUS } from "../components/WhyUS";
import { PackageContainer } from "../components/packageTour/PackageContainer";

export const HomePage = ({ languageId }) => {
  return (
    <>
      <Banner languageId={languageId} />
      <PackageContainer languageId={languageId} />
      <WhyUS languageId={languageId} />
    </>
  );
};
